<template>
  <div>
    <div class="main-container">
      <div class="logo-wrap">
        <img
          class="logo"
          src="https://wenwu3.oss-cn-hangzhou.aliyuncs.com/static/logo_20210422154109.png"
          alt=""
        />
      </div>
      <img
        @click="showCodeImg"
        class="code-img"
        src="https://www.wenwuwangke.com/static/img/app_download.png"
        alt=""
      />
      <div class="title">扫码下载文武教育App</div>
      
      <!-- <div class="company">江苏文武时代教育科技有限公司</div> -->
    </div>

  </div>
</template>

<script>
import api from "@/apis/api";
import tool from "@/common/tool";
import { mapGetters, mapMutations } from "vuex";
import { ImagePreview } from 'vant';
export default {
  name: "Qrcode",
  components: {},
  data() {
    return {
      
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("userModule", ["getToken"]),
  },
  methods: {
    ...mapMutations("userModule", ["SET_TOKEN", "SET_MOBILE"]),
    showCodeImg() {
      ImagePreview([
        'https://www.wenwuwangke.com/static/img/app_download.png'
      ]);
    }
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.main-container {
  text-align: center;
}

.main-container .logo {
  width: 140px;
  height: 30.6px;
  margin-top: 40px;
}
.code-img {
  width: 100px;
  height: 100px;
  margin-top: 30px;
}
.main-container .title {
  font-size: 12px;
  font-weight: 500;
  color: #666666;
}
</style>
